/* The express wallet button right under Add to cart (the owner's default since 2026-09-30), for the
   Bundle & Save box (snippets/bundle-offer.liquid). Product Test Kit v11.3's tp-express.js, fitted to this theme:
   the buy button is the product form's submit, the offer is [data-bo], the wallet markup comes from the cart
   section (sections/main-cart.liquid renders content_for_additional_checkout_buttons), and the header count
   and cart drawer follow through window.theme.refreshCart().
   One button: Apple Pay where the browser can pay with it (iPhone, iPad and Mac Safari), Google Pay everywhere
   else. It pays for exactly what the box shows. Before the button goes live, the cart is set to the box's lines
   (the chosen number and the ticked add-ons) and Shopify's own cart-level accelerated checkout is fetched through
   the Section Rendering API, keeping only the one wallet. Nothing touches the cart until the shopper taps a
   choice in the box or this button, so a page view never counts as an add-to-cart. Needs window.tpoPermalink()
   from bundle-offer.js. If anything fails, a tap goes to checkout with the box's choice, which offers the same
   wallets at the top. Add to cart asks window.tpxIdle() first and calls window.tpxCartChanged() after, so the
   two never put the same choice in the cart twice. */
(function () {
  if (window.__tpx) return;
  window.__tpx = true;
  var script = document.currentScript;
  function attr(n) { return script ? script.getAttribute(n) : null; }
  if (attr('data-wallets') === 'false') return;                 // the store has no express wallets at all
  var payList = attr('data-pay');                                // shop.enabled_payment_types, comma separated
  function enabled(w) { return !payList || (',' + payList + ',').indexOf(',' + w + ',') > -1; }
  var SECTION = 'main-cart';
  var TAG = { apple_pay: 'shopify-apple-pay-button', google_pay: 'shopify-google-pay-button', paypal: 'shopify-paypal-button' };
  var NAME = { apple_pay: 'Apple Pay', google_pay: 'Google Pay', paypal: 'PayPal' };

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var buy = document.querySelector('button[id^="ProductSubmitButton-"], form[data-product-form] [type="submit"]');
    var offer = document.querySelector('[data-tpo], [data-bo]');
    if (!buy || !offer || typeof window.tpoPermalink !== 'function') return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    // Shopify shows Apple Pay only where ApplePaySession supports version 6 and can make payments: same test.
    // In-app browsers that inject scripts (Facebook, Instagram) fail it, so they get Google Pay (PayPal is off on every store since 2026-10-10).
    function canApplePay() {
      try {
        var A = window.ApplePaySession;
        return !!(A && A.supportsVersion && A.supportsVersion(6) && A.canMakePayments && A.canMakePayments());
      } catch (e) { return false; }
    }
    var want = canApplePay() && enabled('apple_pay') ? 'apple_pay' : 'google_pay';
    if (want === 'google_pay' && !enabled('google_pay')) return;

    // ---- the box, right under the Add to cart form -----------------------------------------------
    // .tpx .tpx__slot is display:block on purpose: some themes hide div:empty.
    var css = document.createElement('style');
    css.textContent =
      '.tpx{position:relative;margin:12px 0 0}' +
      '.tpx .tpx__slot{display:block;min-height:var(--tpx-h,54px)}' +
      '.tpx:not(.is-live) .tpx__slot{visibility:hidden;pointer-events:none}' +
      '.tpx shopify-accelerated-checkout-cart{--shopify-accelerated-checkout-button-block-size:var(--tpx-h,54px)!important;--shopify-accelerated-checkout-button-border-radius:var(--tpx-r,10px)!important;--shopify-accelerated-checkout-button-box-shadow:none!important;--shopify-accelerated-checkout-row-gap:0px!important;--shopify-accelerated-checkout-inline-alignment:center!important;display:block;width:100%;margin:0}' +
      '.tpx__ph{position:absolute;left:0;top:0;right:0;z-index:1;display:flex;align-items:center;justify-content:center;gap:.3em;width:100%;height:var(--tpx-h,54px);margin:0;padding:0;border:0;border-radius:var(--tpx-r,10px);cursor:pointer;font:600 17px/1 -apple-system,BlinkMacSystemFont,"Helvetica Neue",Arial,sans-serif;letter-spacing:normal;text-transform:none;-webkit-tap-highlight-color:transparent;overflow:hidden}' +
      '.tpx.is-live .tpx__ph{display:none}' +
      '.tpx[data-wallet="paypal"] .tpx__ph{background:#FFC439;color:#111}' +
      '.tpx__pp{font-style:italic;font-weight:800;color:#003087;letter-spacing:-.01em}' +
      '.tpx[data-wallet="apple_pay"] .tpx__ph,.tpx[data-wallet="google_pay"] .tpx__ph{background:#000;color:#fff}' +
      '.tpx__ap{display:flex;align-items:center;justify-content:center;width:100%;height:100%}' +
      '@supports (-webkit-appearance:-apple-pay-button){.tpx__ap{-webkit-appearance:-apple-pay-button;-apple-pay-button-type:plain;-apple-pay-button-style:black}.tpx__ap > *{display:none}}' +
      '.tpx.is-busy .tpx__ph > :not(.tpx__spin){opacity:.25}' +
      '.tpx__spin{position:absolute;left:50%;top:50%;width:20px;height:20px;margin:-10px 0 0 -10px;border-radius:50%;border:2px solid currentColor;border-right-color:transparent;opacity:0;animation:tpxspin .7s linear infinite}' +
      '.tpx.is-busy .tpx__spin{opacity:1}' +
      '@keyframes tpxspin{to{transform:rotate(360deg)}}' +
      '.tpx__note{margin:8px 0 0;text-align:center;font-size:13px;line-height:1.35;opacity:.85}';
    document.head.appendChild(css);

    var box = document.createElement('div');
    box.className = 'tpx';
    box.innerHTML =
      '<div class="tpx__slot"></div>' +
      '<button type="button" class="tpx__ph"></button>' +
      '<p class="tpx__note" role="status" hidden></p>';
    var slot = box.querySelector('.tpx__slot');
    var ph = box.querySelector('.tpx__ph');
    var note = box.querySelector('.tpx__note');

    function drawPlaceholder() {
      box.setAttribute('data-wallet', want);
      ph.setAttribute('aria-label', 'Pay with ' + NAME[want]);
      ph.innerHTML = want === 'apple_pay'
        ? '<span class="tpx__ap" aria-hidden="true"><span>Pay with Apple Pay</span></span><span class="tpx__spin" aria-hidden="true"></span>'
        : want === 'google_pay' ? '<span>Pay with</span><span class="tpx__gp">Google Pay</span><span class="tpx__spin" aria-hidden="true"></span>' : '<span>Pay with</span><span class="tpx__pp">PayPal</span><span class="tpx__spin" aria-hidden="true"></span>';
    }
    drawPlaceholder();

    var form = buy.closest('product-form') || buy.closest('form') || buy.parentElement;
    form.insertAdjacentElement('afterend', box);

    function size() {
      var h = Math.round(buy.getBoundingClientRect().height) || 54;
      box.style.setProperty('--tpx-h', Math.max(44, Math.min(55, h)) + 'px');   // Shopify's wallets: 25-55 px
      var r = window.getComputedStyle(buy).borderTopLeftRadius;
      if (r) box.style.setProperty('--tpx-r', r);
    }
    size();
    window.addEventListener('resize', size);

    // ---- what the box has chosen ---------------------------------------------------------------------
    function lines() {
      var url = window.tpoPermalink();
      if (!url) return null;
      var out = [];
      String(url).replace(/^.*\/cart\//, '').split('?')[0].split(',').forEach(function (p) {
        var a = p.split(':'), id = parseInt(a[0], 10), q = parseInt(a[1] || '1', 10);
        if (id > 0 && q > 0) out.push({ id: id, quantity: q });
      });
      return out.length ? out : null;
    }
    function keyOf(items) {
      var m = {};
      (items || []).forEach(function (l) { m[l.id] = (m[l.id] || 0) + l.quantity; });
      return Object.keys(m).sort().map(function (id) { return id + ':' + m[id]; }).join(',');
    }
    function cartKey(cart) {
      return keyOf((cart.items || []).map(function (i) { return { id: i.variant_id, quantity: i.quantity }; }));
    }
    function getCart() {
      return fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    function post(path, body) {
      return fetch(root + path, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body || {})
      }).then(function (r) {
        if (!r.ok) throw new Error(path + ' ' + r.status);
        return r.json();
      });
    }
    function sectionHtml() {
      return fetch(window.location.pathname + '?section_id=' + SECTION + '&_=' + Date.now(), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; });
    }
    function themeCart() {                                         // keep the header's count and the cart drawer true
      try { if (window.theme && typeof window.theme.refreshCart === 'function') window.theme.refreshCart().catch(function () {}); } catch (e) {}
    }

    // ---- Shopify's button, one wallet only ------------------------------------------------------------
    function mount(html) {
      var doc = new DOMParser().parseFromString(html || '', 'text/html');
      var el = doc.querySelector('shopify-accelerated-checkout-cart');
      if (!el) return false;
      var cfg;
      try { cfg = JSON.parse(el.getAttribute('wallet-configs') || '[]'); } catch (e) { return false; }
      function only(name) { return cfg.filter(function (c) { return c && c.name === name; }); }
      var pick = only(want);
      if (!pick.length && want === 'apple_pay' && enabled('google_pay')) { want = 'google_pay'; drawPlaceholder(); pick = only('google_pay'); }
      if (!pick.length) return false;
      el.setAttribute('wallet-configs', JSON.stringify(pick));
      slot.textContent = '';
      slot.appendChild(document.importNode(el, true));
      try { if (window.Shopify && window.Shopify.PaymentButton && window.Shopify.PaymentButton.init) window.Shopify.PaymentButton.init(); } catch (e) {}
      return true;
    }
    // Resolves true once Shopify has drawn the wallet, false after 10 s or if superseded.
    function rendered(mine) {
      return new Promise(function (resolve) {
        var t0 = Date.now();
        (function check() {
          if (mine !== seq) return resolve(false);
          var w = slot.querySelector(TAG[want]);
          var tall = !!w && w.getBoundingClientRect().height >= 20;
          if (tall && (want !== 'paypal' || w.querySelector('iframe'))) return resolve(true);
          if (Date.now() - t0 > 10000) return resolve(tall);
          setTimeout(check, 120);
        })();
      });
    }

    // liveKey is set only while the cart holds exactly that choice and its wallet is drawn.
    var liveKey = null, failed = false, seq = 0, timer = null, inflight = null, queue = Promise.resolve();
    function setLive(on) { box.classList.toggle('is-live', !!on); }
    function setBusy(on) { box.classList.toggle('is-busy', !!on); ph.setAttribute('aria-busy', on ? 'true' : 'false'); }
    function say(text) { note.textContent = text || ''; note.hidden = !text; }

    function sync() {
      clearTimeout(timer);
      var items = lines();
      if (!items) return Promise.resolve(false);
      var key = keyOf(items);
      if (key === liveKey) { setLive(true); return Promise.resolve(true); }
      if (inflight && inflight.key === key) return inflight.p;
      var mine = ++seq;
      liveKey = null;
      setLive(false);
      setBusy(true);
      // Cart calls run one sync at a time, so two quick choices can never leave both in the cart.
      var cartDone = queue.then(function () {
        if (mine !== seq) return null;                             // superseded before it started
        var body = { items: items, sections: SECTION, sections_url: window.location.pathname };
        function fresh() { return post('cart/clear.js').then(function () { return post('cart/add.js', body); }); }
        return getCart().then(function (cart) {
          if (mine !== seq) return null;
          if (cart && cart.item_count && cartKey(cart) === key) {  // already in the cart (Add to cart, or a return visit)
            return sectionHtml().then(function (html) { var s = {}; s[SECTION] = html; return { same: true, sections: s }; });
          }
          if (cart && !cart.item_count) {                          // empty: add straight away, then check nothing else crept in
            return post('cart/add.js', body).then(function (data) {
              return getCart().then(function (c) { return c && cartKey(c) === key ? data : fresh(); });
            });
          }
          return fresh();
        });
      });
      queue = cartDone.catch(function () {});
      var p = cartDone
        .then(function (data) {
          if (mine !== seq || !data) return false;
          if (!data.same) themeCart();
          if (!mount(data.sections && data.sections[SECTION])) throw new Error('no wallet');
          return rendered(mine).then(function (ok) { if (!ok && mine === seq) throw new Error('not drawn'); return ok; });
        })
        .then(function (ok) {
          if (mine !== seq || !ok) return false;
          liveKey = key;
          failed = false;
          setLive(true);
          return true;
        })
        .catch(function () {
          if (mine === seq) { liveKey = null; failed = true; }
          return false;
        })
        .then(function (ok) {
          if (mine === seq) { setBusy(false); inflight = null; }
          return ok;
        });
      inflight = { key: key, p: p };
      return p;
    }

    // A choice in the box changed: the live button no longer matches, so hide it and set the cart to the new
    // choice. Runs after the box's own handlers. Taps on text or pictures don't count.
    function changed() {
      say('');
      var items = lines(), key = items ? keyOf(items) : null;
      if (key && key === liveKey && !inflight) { setLive(true); return; }
      setLive(false);
      if (!items) return;
      clearTimeout(timer);
      timer = setTimeout(sync, 400);
    }
    ['click', 'change', 'keydown'].forEach(function (type) {
      offer.addEventListener(type, function (e) {
        if (type === 'keydown' && ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Enter', ' '].indexOf(e.key) < 0) return;
        var t = e.target && e.target.closest && e.target.closest('button, input, select, label, [aria-checked], [role="radio"], [role="checkbox"]');
        if (t && offer.contains(t)) setTimeout(changed, 0);
      }, true);
    });

    // The cart already holds the box's choice (a return visit, or Add to cart just put it there): draw the
    // wallet for it without any cart call. Anything else leaves the placeholder until the next choice or tap.
    function attach() {
      var items = lines(), mine = ++seq;
      clearTimeout(timer);
      inflight = null;
      liveKey = null;
      setLive(false);
      setBusy(false);
      if (!items) return;
      var key = keyOf(items);
      getCart().then(function (cart) {
        if (mine !== seq || !cart || !cart.item_count || cartKey(cart) !== key) return;
        return sectionHtml().then(function (html) {
          if (mine !== seq || !mount(html)) return;
          return rendered(mine).then(function (ok) {
            if (ok && mine === seq) { liveKey = key; failed = false; setLive(true); }
          });
        });
      }).catch(function () {});
    }

    // For Add to cart (bundle-offer.js): wait for any cart call in flight, then tell the button the cart changed.
    window.tpxIdle = function () { clearTimeout(timer); return queue; };
    window.tpxCartChanged = attach;

    function toCheckout() {
      var url = window.tpoPermalink();
      if (url) window.location.href = url;                         // checkout offers the same wallets at the top
    }
    ph.addEventListener('click', function (e) {
      e.preventDefault();
      say('');
      if (!lines()) { buy.click(); return; }
      if (failed && !inflight) { toCheckout(); return; }
      sync().then(function (ok) {
        if (ok) say('Ready: tap ' + NAME[want] + ' to finish.');
        else if (lines()) toCheckout();
      });
    });

    // Back from checkout (page restored from the back-forward cache): drop the button if the cart changed.
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted || !liveKey) return;
      var was = liveKey;
      getCart().then(function (cart) {
        if (liveKey === was && (!cart || cartKey(cart) !== was)) { liveKey = null; setLive(false); }
      });
    });

    // At load: a returning shopper whose cart already holds exactly this choice gets the live button at once.
    attach();
  });
})();
